import React from "react";

function User() {
  return <div>USER</div>;
}

export default User;
